/**
 * HTTP status codes used by the customer-platform API client.
 * Prefer these over raw literals so call sites stay consistent.
 */
export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,

  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,

  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
}

/** True for 2xx responses. */
export function isSuccessStatus(status: number): boolean {
  return status >= HttpStatus.OK && status < 300;
}

/** Transient upstream / gateway failures that callers may soft-handle. */
export const TRANSIENT_HTTP_STATUSES: readonly HttpStatus[] = [
  HttpStatus.SERVICE_UNAVAILABLE,
  HttpStatus.GATEWAY_TIMEOUT,
];
